import React from "react";
import { useNavigate } from "react-router-dom";
import "./UnitCard.css";

const UnitCard = ({ unit, clickable = true }) => {
  const navigate = useNavigate();

  // Enum mapping for UnitType
  const getUnitTypeName = (typeValue) => {
    const unitTypes = {
      0: 'Office',
      1: 'Clinic',
      2: 'Shop'
    };
    return unitTypes[typeValue] || typeValue;
  };

  const handleClick = () => {
    if (clickable) {
      navigate(`/reserve/${unit.Id}`);
    }
  };

  return (
    <div
      className="unit-card"
      onClick={clickable ? handleClick : undefined}
      style={{ cursor: clickable ? 'pointer' : 'default' }}
    >
      <div className="unit-image-placeholder">
        <img 
          src={unit.imageUrl || 'https://placehold.co/600x400'} 
          alt={`Unit ${unit.unitNumber}`}
          onError={(e) => {
            e.target.src = 'https://placehold.co/600x400';
          }}
        />
      </div>
      <div className="unit-content">
        <div className="unit-card-header">
          <h3>{unit.unitNumber}</h3>
          <span className={`unit-status ${unit.UnitStatus}`}>
            {unit.unitStatus}
          </span>
        </div>
        <div className="unit-card-body">
          <div className="unit-info">
            <p><strong>Building:</strong> {unit.BuildingNumber}</p>
            <p><strong>Type:</strong> {getUnitTypeName(unit.UnitType)}</p>
            <p><strong>Floor:</strong> {unit.Floor}</p>
            <p><strong>BUA:</strong> {unit.BUA} m²</p>
            {unit.Area && <p><strong>Area:</strong> {unit.Area} m²</p>}
            {unit.OuterArea && <p><strong>Outdoor Area:</strong> {unit.OuterArea} m²</p>}
          </div>
          <div className="unit-features">
            <p><strong>Bedrooms:</strong> {unit.Bedrooms}</p>
            <p><strong>Bathrooms:</strong> {unit.Bathrooms}</p>
            {/* <p><strong>Living Rooms:</strong> {unit.LivingRooms}</p> */}
            {/* <p><strong>Kitchen:</strong> {unit.Kitchen}</p> */}
            {/* <p><strong>Balcony:</strong> {unit.Balcony}</p> */}
          </div>
          <div className="unit-price">
            <h4>Price: ${unit.Price}</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitCard; 